export const SITE = {
  name: "Chennai Packs",
  tagline: "Premium Food Packaging Supplier",
  phone: "+91 7339252701",
  phoneRaw: "917339252701",
  whatsapp: "918870705520",
  email: "sales@chennaipacks.com",
  addressLines: [
    "Jes Mes Enterprises, 573, 4th Cross Street, North,",
    "Sivaprakasam Nagar, Surapet,",
    "Chennai, Tamil Nadu 600066",
  ],
  addressShort: "Surapet, Chennai, Tamil Nadu 600066",
  mapQuery:
    "Jes Mes Enterprises 573 4th Cross Street Sivaprakasam Nagar Surapet Chennai Tamil Nadu 600066",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Custom Branding", to: "/custom-branding" },
  { label: "Industries", to: "/industries" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
